import React, { useState } from 'react';
import { ActionContextMenu } from './PlaytestCardContextMenu';
import { boardActions } from '../utils/cardActions';

/**
 * Kontextmenü der freien Brettfläche am Rechner (Spec 2026-10-21 §5.6): Token erzeugen,
 * Würfeln (Untermenü W4–W100, Münze), Alle enttappen.
 *
 *   <BattlefieldContextMenu onCreateToken={(screenPt) => openTokenPicker(toWorld(screenPt))}
 *     onRollDice={rollDice} onUntapAll={untapAll}>
 *     <Battlefield … />
 *   </BattlefieldContextMenu>
 *
 * - `onCreateToken(position)`: `position` ist die Klickstelle in Client-Koordinaten
 *   (`{ x, y }`); die Umrechnung in Weltkoordinaten übernimmt die Seite.
 * - Die Kinder liegen in einem Element mit `display: contents`, das Layout bleibt unberührt.
 *   Karten fangen ihren Rechtsklick selbst ab (`stopPropagation`), das Menü öffnet also nur
 *   auf freier Fläche.
 * - Radix öffnet das Menü bei Touch auch auf Langdruck. Am Handy zeigt die Seite stattdessen
 *   `ActionSheet` mit `boardActions(…)` und umschließt die Fläche nicht mit diesem Menü.
 */
export default function BattlefieldContextMenu({ children, onCreateToken, onRollDice, onUntapAll }) {
  const [position, setPosition] = useState(null);
  const actions = boardActions({ onCreateToken, onRollDice, onUntapAll }, position);

  return (
    <ActionContextMenu actions={actions}>
      <div
        className="battlefield-context-menu"
        style={{ display: 'contents' }}
        data-testid="battlefield-context-menu"
        onContextMenu={(e) => setPosition({ x: e.clientX, y: e.clientY })}
      >
        {children}
      </div>
    </ActionContextMenu>
  );
}
